export const ACCOUNT_TYPE = {
  CREDENTIAL: 'credential',
  CREDENTIALLESS: 'credentialless',
};

export const EXTEND_MSGS = {
  extendFailedDefaultMessage: {
    id: 'pam.extend.failed.default',
    defaultMessage: 'Session Extend failed. Please contact administrator.',
  },
  extendBeforeStartErrorMessage: {
    id: 'pam.extend.failed.extendBeforeStartError',
    defaultMessage:
      'Session Extend failed. The session cannot be extended until after it has started.',
  },
  alertBannerFailureTitle: {
    id: 'pam.checkin.failedTitle',
    defaultMessage: `Failed!`,
  },
  alertBannerSuccessTitle: {
    id: 'pam.checkin.successTitle',
    defaultMessage: `Success!`,
  },
};
